import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import {
  sm_mobile_breakpoint,
  tablet_portrait_breakpoint,
  sm_laptop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const HeroStyles = styled.div`
  .inner {
    height: 416px;
    overflow: hidden;
    position: relative;

    .hero-image-desktop,
    .hero-image-mobile {
      height: 100%;
    }

    .overlay {
      background-color: rgba(0, 117, 201, 0.7);
      position: absolute;
      inset: 0;
      z-index: 1;
    }

    .text-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: end;
      z-index: 2;
    }

    .hero-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: end;
      padding: 0 24px;

      h1 {
        font-size: 34px;
        font-weight: 700;
        padding-bottom: 16px;
      }

      p {
        font-size: 16px;
        font-weight: 400;
      }

      h1,
      p {
        color: ${Colors.primary.white.standard};
      }
    }
  }

  @media screen and (min-width: ${sm_mobile_breakpoint}px) {
    .inner {
      .hero-container {
        padding-bottom: 3rem;
      }
    }
  }

  @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .inner {
      height: 640px;

      .overlay {
        top: 0;
        left: 50%;
      }

      .hero-container {
        align-items: left;
        justify-content: center;
        padding: 0 48px;
        width: 50%;
        h1 {
          font-size: 40px;
          padding-bottom: 18px;
        }

        p {
          font-size: 18px;
        }
      }
    }
  }

  @media screen and (min-width: ${sm_laptop_breakpoint}px) {
    .inner {
      .hero-container {
        padding: 18px 90px;
        align-items: left;
      }
    }
  }
`;

export default HeroStyles;
